<template>
  <WorkPackageSubPageModule
    :workpackage="{textcolor: '#fff'}"
    :isMobile="true"
    :location="location"
    :loading="loading"
    background_color="#424242"
    foreground_color="#fff"
    header_icon="mdi-qrcode"
    header_text_short="QR"
    header_text_long="QR.codes"
    @headerBack="$router.push({name: `${location}TaktareaDetailsInfo`})"
    >
    <template #header-rightside>
      <v-btn class="ma-1" icon :color="show_search?'#fff':'#fff'" :class="show_search?workpackage.textcolor:''" @click="show_search = !show_search"><v-icon>search</v-icon></v-btn>
      <v-btn
        class="ma-1"
        icon
        :color="'#fff'"
        @click="$router.push({
          name: `${location}TaktareaDetailsQRCodesDetails`,
          params: {
            content_id: 'create'
          }
        })"
        >
        <v-icon>add</v-icon>
      </v-btn>
    </template>
    <template #header-below>
      <!-- SEARCH -->
      <SearchBar
        v-if="show_search"
        :background_color="'#424242'"
        :foreground_color="'#fff'"
        :is_live_emit="true"
        @search="search=$event || ''"
      />
      <!-- @search="" -->
    </template>
    <template #sort-buttons>
        <!-- SELECT FILTER -->
        <DropDown
          :items="search_filter_items"
          :value="filter"
          placeholder="Sorting"
          :background_color="'#424242'"
          :foreground_color="'#fff'"
          @selected="filter=$event"
          style="z-index: 100"
        />
    </template>
    <template #body>
      <!-- <div style="width: 200px; height: 200px; background-color: red" @click="test()"/> -->
      <WorkPackageQrList
        :categorized_qr_codes="getQRCodes({taktarea_id: taktarea.id, search, filter})"
        :background_color="'#424242'"
        :foreground_color="'#fff'"
        @emittedClick="$router.push({
          name: `${location}TaktareaDetailsQRCodesDetails`,
          params: {
            content_id: $event
          }
        })"
      />
    </template>
  </WorkPackageSubPageModule>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue';
import DropDown from '@/components/WorkPackageWIP/DropDown.component.vue';

import WorkPackageQrList from '@/modules/WorkPackageWIP/WorkPackageQrList.module.vue'
import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
import { TrainTaktareaDetailsMixin } from '@/mixins/TrainTaktareaDetails.mixin.js'

  export default {
    components: {
      WorkPackageSubPageModule,
      WorkPackageQrList,
      SearchBar,
      DropDown
    },
    mixins: [TrainTaktareaDetailsMixin],
    props: [],
    data: () => ({
      search: '',
      loading: false,
      show_search: false,
      filter: 'Latest',
      search_filter_items: [
        'Latest', 'Description', 'Date', 'Person',
      ],
    }),
    created() {
      this.loadData();
    },
    computed: {
      ...mapGetters('TaktArea', [
        'getQRCodes',
      ]),
    },
    methods: {
      ...mapActions('Ultra', [
        'createUObject',
        'updateUObject',
        'deleteUObject',
        'updateUObjectPosition',
      ]),
      loadData() {
        this.loading = true;
        this.$store.dispatch('Ultra/requestUObject', {
          url: [
            {projects: this.$route.params.project_id},
            {trains: this.$route.params.train_id},
            {taktareas: this.$route.params.taktarea_id},
            {tags: ''},
            {showWithEntitiesNormalized: ''}
          ],
          add_u_object: true
        })
        .then(() => {
          this.loading = false;
        });
      }
    },
  }
</script>
<style scoped>

</style>
